<template>
    <VideoHeader
        :banner="contentMeta.banner"
    >
        <template #default>
            <h1 class="page-title">{{ contentMeta.h1 }}</h1>
        </template>
    </VideoHeader>
</template>

<script lang="ts" setup>
    import type {
        ContentMeta
    } from '~/types';
    import VideoHeader from '~/components/video/VideoHeader/VideoHeader.vue';

    defineProps<{
        contentMeta: ContentMeta;
    }>();
</script>

<style lang="scss"></style>
